// Was dieses Produkt verschickt. Prosa statt Chrome, also neben dem Katalog
// wie `legal-*.js` und flach hineingespreizt — der Key-Paritäts-Test deckt sie
// dadurch ab, ohne von ihnen wissen zu müssen.
//
// **Der Grund, aus dem `users.locale` überhaupt existiert.** Die Roadmap sagt
// es beim Migrationseintrag: Anmeldecodes sind der einzige Faktor, also ist
// eine Mail, die der Empfänger nicht lesen kann, kein Schönheitsfehler sondern
// eine Aussperrung. Die Spalte lag seit `009-locale.sql` da und jede Mail ging
// trotzdem auf Deutsch raus.
//
// Ganze Sätze statt Bausteine: eine Mail hat keinen Platz, in dem ein
// zusammengesetzter Halbsatz noch gut aussieht, und die beiden Sprachen bauen
// Anrede und Abbinder verschieden.

export default {
  mailCodeSubject: (code) => `${code} ist dein Code für tba.tips`,
  mailCodeBody: (code, minutes) => [
    `Dein Anmeldecode: ${code}`,
    ``,
    `Er gilt ${minutes} Minuten und nur in dem Fenster, in dem du ihn angefordert hast.`,
    `Wenn du das nicht warst, ignoriere diese Mail.`,
  ].join('\n'),

  // Der Betreff trägt die Zahl, weil er im Postfach die einzige Zeile ist, die
  // entscheidet, ob jemand aufmacht.
  mailDigestSubject: (count) => `Diese Woche: ${count === 1 ? 'ein Termin' : `${count} Termine`}`,
  mailDigestGreeting: (name) => (name ? `Hallo ${name},` : 'Hallo,'),
  // "Orte" wäre hier das Wort, das der Locale-Test als Label verbietet — es
  // meinte einmal Institutionen, den Folge-Feed und Adressen gleichzeitig.
  mailDigestLede: 'das haben die Institutionen angekündigt, denen du folgst:',
  mailDigestAll: (url) => `Alles ansehen: ${url}`,
  mailDigestUnsubscribe: (url) => `Diese Mail bekommst du, weil du sie angefordert hast. Abbestellen: ${url}`,

  mailInviteSubject: (account) => `Du wurdest zu ${account} eingeladen`,
  mailInviteBody: (account, url, days) => [
    `${account} hat dich eingeladen, das Programm auf tba.tips mitzupflegen.`,
    ``,
    `Einladung annehmen: ${url}`,
    ``,
    `Der Link gilt ${days} Tage und funktioniert nur mit dieser E-Mail-Adresse.`,
  ].join('\n'),
};
